import React, { useState } from "react";
import { Box, Paper, Tabs, Tab } from "@mui/material";
import ReportsTap from "../components/PagesComponents/ReportsComponents/DailySessionReports/reportsTap"; // ✅ Import ReportsTap
import GeneralReportsTap from "../components/PagesComponents/ReportsComponents/GeneralReportsTap/GeneralReportsTap"; // ✅ Import GeneralReportsTap

const Reports = () => {
  // CHANGED: init from localStorage to persist tab across refresh
  const [activeTab, setActiveTab] = useState(() => {
    const v = localStorage.getItem("reports_active_tab");
    return v !== null ? Number(v) : 0;
  });

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    localStorage.setItem("reports_active_tab", String(newValue));
  };

  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ padding: 3, mt: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange} centered>
          {/* احذف تاب الإحصائيات */}
          {/* <Tab label="الإحصائيات" /> */}
          <Tab label="التقارير" />
          <Tab label="التقارير العامة" />
        </Tabs>
      </Paper>
      <Box sx={{ mt: 3 }}>
        {/* عرض المحتوى حسب التاب المحدد */}
        {activeTab === 0 && (
          <Box>
            <ReportsTap />
          </Box>
        )}
        {activeTab === 1 && (
          <Box>
            <GeneralReportsTap />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default Reports;


